import { WHITELABEL_NAME } from 'lib/api/whitelabel/getWhiteLabel';
import { useAuth } from 'lib/context';
import { useCDK } from 'lib/hooks/useCdk';
import * as React from 'react';
import Helmet from 'react-helmet';

type Props = {
  description?: string;
  lang?: string;
  title: string;
};

export const DocumentHead = ({ description, lang = 'en', title }: Props) => {
  const { whitelabel } = useAuth();
  const { isCdkUser } = useCDK();

  // themeName is called from the context,
  // and it returns the theme name based on the whitelabel and on resellerId

  const titleTemplate = isCdkUser ? WHITELABEL_NAME.CDK : whitelabel?.name;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={'%s - ' + titleTemplate}
      meta={[
        {
          name: `description`,
          content: description,
        },
      ]}
    />
  );
};
